import React from "react";
import ForumSection from './ForumSection';


function getText(el, selector){
    if(!el){
        return '';
    }

    let child = el.querySelector(selector);
    return child ? child.textContent.trim() : '';
}

function getAll(el, selector){
    if(!el){
        return [];
    }
    return Array.from(el.querySelectorAll(selector));
}

export default class Forum extends React.Component {
    render(){
        let config = this.props.config;
        if(!config){
            return (<span>Loading</span>);
        }

        let title = getText(config, 'title');
        let baseUrl = getText(config, 'baseUrl');
        let catalogs = getAll(config, 'catalogs catalog').map(catalog => {
            return {
                tech: getText(catalog, 'tech'),
                href: getText(catalog, 'href'),
                title: getText(catalog, 'title'),
                description: getText(catalog, 'description')
            };
        });
        let actions = {
            viewAll: getText(config, 'actions viewAll'),
            spark: getText(config, 'actions spark'),
        };

        return (
            <ForumSection {...{title, baseUrl, catalogs, actions}}/>
        );
    }
}